import {
  type MutationState,
  useMutation,
} from 'src/core/api/hooks/useMutation';
import { type AssignableRole } from 'src/core/modules/members/models/roles';

type Payload = {
  previousAoNextRoles: Array<AssignableRole>;
  nextAoUserId: string;
};

export const useInitiateUkAoChangeMutation = (): MutationState<Payload> => {
  return useMutation<Payload>({
    request: {
      type: 'rest',
      method: 'post',
      target: 'companyAPI',
      endpoint: '/account-ownership/uk/initiate-request',
    },
    options: {
      onSuccess: ({ client }) => {
        client.invalidateQueries({
          queryKey: ['aoChangeEligibility'],
        });
        client.invalidateQueries({
          queryKey: ['getAoChangeRequest'],
        });
      },
    },
  });
};
